<template>
  <div>
    <span v-if="enableHeader">
      <registration-header
        :regFilterPermissisonFlag="regFilterPermissisonFlag"
        :threeDotsPermissionFlag="threeDotsPermissionFlag"
        :permissions="permissions"
        :roleId="roleId"
        :totalRecordCountDetails="totalRecordCountDetails"
        :openRegistration="openRegistration"
        :searchRegistration="searchRegistration"
        @getUserRecordCount="getUserRecordCount"
        :roleInfo="roleInfo"
        :complianceQuery="complianceQuery"
      ></registration-header>
    </span>

    <span>
      <loader :loadingStatus="loaderStatus"></loader>
    </span>
  </div>
</template>

<script>
import { sortBy } from 'lodash';
import RegistrationHeader from './RegistrationHeader.vue';
import Loader from '../UIComponents/Loader.vue';
import permissionsList from '../UIComponents/mixins/rbacPermissionsMixin';

export default {
  mixins: [permissionsList],
  props: ['openRegistration', 'searchRegistration', 'roleInfo'],
  data() {
    return {
      regFilterPermissisonFlag: false,
      threeDotsPermissionFlag: false,
      permissions: [],
      loaderStatus: false,
      totalRecordCountDB: 0,
      enableHeader: false,
      totalCountForDisplay: 0,
      roleId: '',
      complianceQuery: '',
      totalRecordCountDetails: [
        {
          key: 'totalcount',
          displayFilter: 'View All',
          showIndex: 0
        },
        {
          key: 'active',
          displayFilter: 'Active',
          showIndex: 2
        },
        {
          key: 'expired',
          displayFilter: 'Expired',
          showIndex: 3
        },
        {
          key: 'expiringsoon',
          displayFilter: 'Action Needed',
          showIndex: 4
        },
        {
          key: 'pending',
          displayFilter: 'Pending',
          showIndex: 1
        },
        {
          key: 'archived',
          displayFilter: 'Archive',
          showIndex: 5
        },
        {
          key: 'save_draft',
          displayFilter: 'Draft',
          showIndex: 6
        },
        {
          key: 'invalid_records',
          displayFilter: 'Invalid Records',
          showIndex: 7
        }
      ]
    };
  },
  components: {
    RegistrationHeader,
    Loader,
  },
  methods: {
    async validateFeatures() {
      this.threeDotsPermissionFlag = false;
      this.regFilterPermissisonFlag = false;
      this.permissions = [];
      const servicesList = ['REG_TRACKER'];
      const modulesList = ['REG_TRACKER_RECORDS'];
      this.permissions = await this.permissionsList(servicesList, modulesList);
      if (this.permissions.indexOf('REG_TRACKER_RECORDS') === -1) {
        this.$router.push('/layout/PermissionAccess');
      } else {
        if (this.permissions.indexOf('EXPORT_REGISTRATION') > -1 || this.permissions.indexOf('EMAIL_REGISTRATION_SHARE') > -1
          || this.permissions.indexOf('ATTACH_A_FILE') > -1 || this.permissions.indexOf('ARCHIEVE_A_REGISTRATION') > -1
          || (this.permissions.indexOf('UNARCHIEVE_A_REGISTRATION')) > -1 || this.permissions.indexOf('DELETE_A_REGISTRATION') > -1) {
          this.threeDotsPermissionFlag = true;
        }
        if (this.permissions.indexOf('RECORDS_WITH_ATTACHMENT') > -1 || this.permissions.indexOf('AFFECTED_BY_REGULATORY_ALERT') > -1
          || this.permissions.indexOf('APPROVAL_DATES_WITH_OPTIONS') > -1 || this.permissions.indexOf('EXPIRATION_DATES') > -1
          || this.permissions.indexOf('COUNTRY_WISE_FILTER_AND_SEARCH') > -1 || this.permissions.indexOf('CLEAR_ALL') > -1
          || this.permissions.indexOf('COLUMN_OPTIONS') > -1) {
          this.regFilterPermissisonFlag = true;
        }
      }
    },
    async getUserRecordCount() {
      this.totalCountForDisplay = 0;
      this.totalRecordCountDetails = sortBy(
        this.totalRecordCountDetails,
        'showIndex',
      );
      this.enableHeader = true;
    },
  },
  async created() {
    this.complianceQuery = this.$route.query.compliance;
    this.roleId = JSON.parse(localStorage.getItem('userData')).role_id;
    await this.getUserRecordCount();
    await this.validateFeatures();
  },
};
</script>
<style></style>
